const BOOKING_IMAGES_URL = '/webservice/get-booking-images/';
const BOOKING_PDFS_URL = '/webservice/get-booking-pdfs/';

module.exports = {
    getBookingImages: function getBookingImages(booking_id, company_name, company_id) {
        return window.axios.get(BOOKING_IMAGES_URL, { params:
                {
                    booking_id: booking_id,
                    company_name: company_name,
                    company_id: company_id
                }
        });
    },
    getBookingPdfs: function getBookingPdfs(booking_id, company_name, company_id) {
        return window.axios.get(BOOKING_PDFS_URL, { params:
                {
                    booking_id: booking_id,
                    company_name: company_name,
                    company_id: company_id
                }
        });
    },


};
